export interface Movie {
  id: number;
  title: string;
  englishTitle: string;
  year: number;
  rating: number;
  category: string;
  region: string;
  coverImage: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  isHot: boolean;
  isNew: boolean;
  rank: number;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-2-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { slug: 'scifi', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画', icon: 'ri-palette-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '星际穿越',
    englishTitle: 'Interstellar',
    year: 2014,
    rating: 9.4,
    category: 'scifi',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Interstellar%20style%20sci-fi%20film%2C%20astronaut%20floating%20near%20a%20massive%20black%20hole%20with%20wormhole%20visuals%2C%20deep%20space%20background%20with%20stars%20and%20nebulae%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20dark%20and%20mysterious%20atmosphere%2C%20cinematic%20movie%20poster%20design%20with%20warm%20golden%20accents%20on%20dark%20background&width=600&height=900&seq=movie-cover-01&orientation=portrait',
    description: '近未来的地球黄沙遍野，小麦、秋葵等基础农作物相继因枯萎病灭绝，人类不再像从前那样仰望星空，而是每日在沙尘暴的肆虐下倒数着所剩不多的光景。在家务农的前NASA宇航员库珀接连在女儿墨菲的书房发现奇怪的重力场现象，随即得知在某个未知区域内前NASA成员仍秘密进行一个拯救人类的计划。',
    director: '克里斯托弗·诺兰',
    actors: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    duration: '169分钟',
    isHot: true,
    isNew: false,
    rank: 1,
  },
  {
    id: 2,
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    year: 2026,
    rating: 8.8,
    category: 'scifi',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20for%20The%20Wandering%20Earth%203%20style%2C%20Earth%20with%20massive%20thruster%20engines%20in%20deep%20space%2C%20futuristic%20space%20station%20and%20planets%20in%20background%2C%20dramatic%20cinematic%20lighting%20with%20orange%20and%20blue%20contrast%2C%20epic%20scale%2C%20clean%20dark%20background%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-02&orientation=portrait',
    description: '太阳急速老化，持续膨胀，一百年后将吞没地球。为了生存，人类提出名为"流浪地球"的大胆计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，用2500年的时间奔往新家园。第三部中，人类面临着前所未有的新挑战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '173分钟',
    isHot: true,
    isNew: true,
    rank: 2,
  },
  {
    id: 3,
    title: '热辣滚烫',
    englishTitle: 'YOLO',
    year: 2024,
    rating: 8.2,
    category: 'comedy',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20style%2C%20a%20determined%20woman%20in%20boxing%20gloves%20facing%20the%20camera%20with%20intense%20expression%2C%20warm%20lighting%2C%20gym%20background%20with%20punching%20bag%2C%20inspirational%20mood%2C%20professional%20movie%20poster%20design%20with%20rich%20warm%20tones&width=600&height=900&seq=movie-cover-03&orientation=portrait',
    description: '乐莹自从大学毕业工作一段时间后，选择脱离社会，宅在家里长达十年。在命运的几番捉弄下，她决定换一种方式生活，与外面的世界小心翼翼地接触。在与拳击教练昊坤的相识相知中，她找到了人生的新方向。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '129分钟',
    isHot: true,
    isNew: false,
    rank: 3,
  },
  {
    id: 4,
    title: '飞驰人生3',
    englishTitle: 'Pegasus 3',
    year: 2026,
    rating: 8.5,
    category: 'comedy',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%2C%20a%20rally%20race%20car%20speeding%20on%20desert%20track%20with%20dust%20trail%2C%20dramatic%20sunset%20sky%20with%20warm%20golden%20light%2C%20action-packed%20cinematic%20feeling%2C%20professional%20movie%20poster%20design%20with%20clean%20composition&width=600&height=900&seq=movie-cover-04&orientation=portrait',
    description: '曾经的赛车冠军张驰如今落魄潦倒，靠经营驾校勉强糊口。但当他接到一通电话后，决定重返巴音布鲁克赛道，挑战不可能。这一次，他将带领新老搭档一起，再次冲向梦想的终点线。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    duration: '136分钟',
    isHot: false,
    isNew: true,
    rank: 4,
  },
  {
    id: 5,
    title: '消失的她',
    englishTitle: 'Lost in the Stars',
    year: 2023,
    rating: 8.7,
    category: 'suspense',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20in%20Chinese%20style%2C%20a%20mysterious%20woman%20silhouette%20disappearing%20into%20shadows%2C%20dark%20ocean%20and%20underwater%20themes%2C%20dramatic%20moody%20lighting%20with%20deep%20blues%20and%20teal%20accents%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-05&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。在他苦寻无果之际，妻子再次现身，何非却坚持眼前的女人并非李木子。夫妻二人似乎都有不可告人的秘密，随着金牌律师陈麦介入这起离奇案件，更多的谜团慢慢浮现。',
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '121分钟',
    isHot: true,
    isNew: false,
    rank: 5,
  },
  {
    id: 6,
    title: '孤注一掷',
    englishTitle: 'No More Bets',
    year: 2023,
    rating: 8.6,
    category: 'drama',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20movie%20poster%2C%20a%20tense%20scene%20with%20computer%20screens%20and%20money%20scattered%20on%20desk%2C%20dark%20underground%20office%20setting%2C%20neon%20red%20and%20amber%20lighting%2C%20psychological%20thriller%20mood%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-06&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘所吸引，憧憬着出国淘金，却意外卷入了一场精心策划的网络骗局。他们被困在诈骗工厂中，面对残酷的现实，必须找到逃出生天的方法。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君', '咏梅'],
    duration: '130分钟',
    isHot: true,
    isNew: false,
    rank: 6,
  },
  {
    id: 7,
    title: '长安三万里',
    englishTitle: 'Chang An',
    year: 2023,
    rating: 8.9,
    category: 'animation',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20ancient%20Tang%20Dynasty%20Changan%20cityscape%20with%20traditional%20Chinese%20architecture%2C%20poet%20on%20horseback%20under%20moonlight%2C%20warm%20golden%20and%20crimson%20tones%2C%20artistic%20ink%20painting%20style%20blended%20with%203D%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-07&orientation=portrait',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事，两位大诗人的命运在大时代中跌宕起伏。',
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    isHot: true,
    isNew: false,
    rank: 7,
  },
  {
    id: 8,
    title: '哪吒之魔童闹海',
    englishTitle: 'Nezha 2',
    year: 2025,
    rating: 9.1,
    category: 'animation',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20young%20mythological%20warrior%20Nezha%20with%20flaming%20wheels%20and%20red%20silk%20ribbon%2C%20stormy%20ocean%20with%20dragon%20in%20background%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20cinematic%20composition%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-08&orientation=portrait',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲为二人重塑肉身。但在这个过程中，他们遇到了更大的灾难，哪吒必须再次挺身而出，守护陈塘关。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    duration: '144分钟',
    isHot: true,
    isNew: true,
    rank: 8,
  },
  {
    id: 9,
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    year: 2025,
    rating: 8.4,
    category: 'action',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20warrior%20in%20armor%20holding%20a%20sword%2C%20mythological%20creatures%20and%20gods%20in%20battle%2C%20dramatic%20sky%20with%20thunder%20and%20fire%2C%20golden%20and%20crimson%20color%20scheme%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-09&orientation=portrait',
    description: '大商二王子殷寿带领亲手调教的质子旅和殷商大军征讨叛乱的冀州侯苏护，意外解除了轩辕坟中妖狐的封印。妖狐附身苏护之女妲己，与殷寿内外勾结，试图颠覆天下。姜子牙携封神榜下山，寻找天下共主。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    duration: '148分钟',
    isHot: false,
    isNew: true,
    rank: 9,
  },
  {
    id: 10,
    title: '长津湖',
    englishTitle: 'The Battle at Lake Changjin',
    year: 2021,
    rating: 9.0,
    category: 'action',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%2C%20soldiers%20in%20winter%20battle%20gear%20marching%20through%20snowy%20mountain%20terrain%2C%20frozen%20lake%20in%20background%2C%20dramatic%20cold%20blue%20and%20white%20tones%2C%20epic%20scale%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-10&orientation=portrait',
    description: '1950年，中国志愿军部队与美军在朝鲜长津湖地区交战。中国人民志愿军第9兵团将美军1个多师分割包围于长津湖地区，歼敌1.3万余人，扭转了战场态势。这次战役收复了三八线以北的东部广大地区，是扭转局势的关键一战。',
    director: '陈凯歌 / 徐克 / 林超贤',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    duration: '176分钟',
    isHot: false,
    isNew: false,
    rank: 10,
  },
  {
    id: 11,
    title: '你好，李焕英',
    englishTitle: 'Hi, Mom',
    year: 2021,
    rating: 9.2,
    category: 'comedy',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20family%20movie%20poster%2C%20mother%20and%20daughter%20laughing%20together%20in%20vintage%201980s%20Chinese%20factory%20setting%2C%20warm%20nostalgic%20amber%20tones%2C%20heartwarming%20mood%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-11&orientation=portrait',
    description: '2001年的某一天，刚考上大学的贾晓玲遭遇了人生中的一次大变故。一心想要成为母亲骄傲的她，竟意外回到了1981年，与年轻时的母亲李焕英相遇。晓玲以为来到了这片"广阔天地"，可以凭借自己超前的思维，让母亲"大有作为"。',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾', '陈赫'],
    duration: '128分钟',
    isHot: false,
    isNew: false,
    rank: 11,
  },
  {
    id: 12,
    title: '满江红',
    englishTitle: 'Full River Red',
    year: 2023,
    rating: 8.5,
    category: 'suspense',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%2C%20Song%20Dynasty%20military%20compound%20with%20soldiers%20in%20ancient%20armor%2C%20mysterious%20atmosphere%20with%20lantern%20lighting%2C%20deep%20crimson%20and%20black%20color%20scheme%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-12&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    isHot: false,
    isNew: false,
    rank: 12,
  },
  {
    id: 13,
    title: '熊出没·逆转时空',
    englishTitle: 'Boonie Bears: Time Twist',
    year: 2024,
    rating: 7.9,
    category: 'animation',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animated%20family%20movie%20poster%2C%20two%20cartoon%20bears%20and%20a%20man%20in%20a%20time%20machine%20surrounded%20by%20clock%20gears%20and%20colorful%20time%20portals%2C%20bright%20and%20fun%20tone%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-13&orientation=portrait',
    description: '光头强和熊大熊二意外获得了一台可以穿越时空的神秘机器，他们由此踏上了一段穿越不同时代的奇妙冒险。在时空中，他们遇到了各种意想不到的挑战和惊喜。',
    director: '林汇达',
    actors: ['张伟', '张秉君', '谭笑', '张茗'],
    duration: '100分钟',
    isHot: false,
    isNew: false,
    rank: 13,
  },
  {
    id: 14,
    title: '第二十条',
    englishTitle: 'Article 20',
    year: 2024,
    rating: 8.3,
    category: 'drama',
    region: '中国大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%2C%20a%20serious%20courtroom%20scene%20with%20judge%20and%20lawyers%2C%20scales%20of%20justice%20symbolism%2C%20subdued%20and%20professional%20tone%2C%20clean%20composition%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-14&orientation=portrait',
    description: '人过中年的检察官韩明早已没了往日的锋芒，每日在工作和家庭之间疲于奔命。但当一起看似普通的案件摆在他面前时，韩明发现其中暗藏玄机，他必须重新审视自己对法律和正义的信仰。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    duration: '131分钟',
    isHot: false,
    isNew: false,
    rank: 14,
  },
  {
    id: 15,
    title: '奥本海默',
    englishTitle: 'Oppenheimer',
    year: 2023,
    rating: 9.3,
    category: 'drama',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%20Oppenheimer%20style%2C%20a%20man%20in%20vintage%20suit%20and%20fedora%20hat%20staring%20into%20distance%2C%20mushroom%20cloud%20in%20background%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20intense%20and%20contemplative%20mood%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-15&orientation=portrait',
    description: '二战期间，美国"原子弹之父"罗伯特·奥本海默领导曼哈顿计划，成功研制出世界上第一颗原子弹。然而，当他亲眼目睹原子弹的毁灭性威力后，他的内心陷入了深深的矛盾和挣扎。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    isHot: false,
    isNew: false,
    rank: 15,
  },
  {
    id: 16,
    title: '阿凡达3',
    englishTitle: 'Avatar 3',
    year: 2025,
    rating: 8.6,
    category: 'scifi',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Avatar%20movie%20poster%20style%2C%20blue%20Navi%20alien%20character%20riding%20a%20flying%20creature%20in%20a%20bioluminescent%20Pandora%20forest%2C%20vibrant%20alien%20plants%20and%20floating%20mountains%2C%20epic%20cinematic%20composition%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-16&orientation=portrait',
    description: '杰克·萨利和奈蒂莉拥有了家庭，为了生存，他们被迫离开家园。他们将探索潘多拉星球的各个不同区域，并遇到使用火元素的"灰烬族"。一场更大的冲突即将在潘多拉上演。',
    director: '詹姆斯·卡梅隆',
    actors: ['萨姆·沃辛顿', '佐伊·索尔达娜', '西格妮·韦弗', '史蒂芬·朗'],
    duration: '192分钟',
    isHot: false,
    isNew: true,
    rank: 16,
  },
  {
    id: 17,
    title: '毒液3',
    englishTitle: 'Venom 3',
    year: 2024,
    rating: 7.8,
    category: 'action',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Venom%20superhero%20movie%20poster%2C%20black%20symbiote%20creature%20with%20white%20eyes%20and%20sharp%20teeth%20looming%20over%20city%20skyline%2C%20dark%20and%20edgy%20with%20subtle%20red%20accents%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-17&orientation=portrait',
    description: '埃迪·布洛克和毒液这对不搭调的组合再次面临巨大威胁。一个来自毒液母星的更强大的共生体降临地球，他们必须联手新老盟友，保护这个世界免遭毁灭。',
    director: '凯莉·马塞尔',
    actors: ['汤姆·哈迪', '朱诺·坦普尔', '切瓦特·埃加福特'],
    duration: '127分钟',
    isHot: false,
    isNew: false,
    rank: 17,
  },
  {
    id: 18,
    title: '死侍3',
    englishTitle: 'Deadpool 3',
    year: 2024,
    rating: 8.1,
    category: 'action',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Deadpool%20superhero%20comedy%20movie%20poster%2C%20red-suited%20antihero%20with%20mask%20posing%20with%20swords%20in%20action%20stance%2C%20chaotic%20and%20fun%20energy%2C%20red%20and%20black%20color%20scheme%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-18&orientation=portrait',
    description: '死侍被时间变异管理局（TVA）抓走，并被告知他将加入漫威电影宇宙。为了拯救自己的宇宙，死侍不得不与金刚狼组队，展开一场跨越多元宇宙的疯狂冒险。',
    director: '肖恩·利维',
    actors: ['瑞安·雷诺兹', '休·杰克曼', '艾玛·科林'],
    duration: '128分钟',
    isHot: false,
    isNew: false,
    rank: 18,
  },
  {
    id: 19,
    title: '沙丘2',
    englishTitle: 'Dune: Part Two',
    year: 2024,
    rating: 9.0,
    category: 'scifi',
    region: '美国',
    coverImage: 'https://readdy.ai/api/search-image?query=Dune%20epic%20sci-fi%20movie%20poster%2C%20a%20figure%20in%20desert%20stillsuit%20standing%20on%20a%20massive%20sand%20dune%2C%20giant%20sandworm%20emerging%20from%20below%2C%20harsh%20sunlight%20and%20golden%20dust%20atmosphere%2C%20epic%20scale%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-19&orientation=portrait',
    description: '保罗·厄崔迪与契妮和弗雷曼人联手，踏上复仇之路。他必须在爱情和宇宙命运之间做出选择，并努力阻止只有他能预见的可怕未来。整个宇宙的命运都悬于一线。',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚', '丽贝卡·弗格森', '乔什·布洛林'],
    duration: '166分钟',
    isHot: false,
    isNew: false,
    rank: 19,
  },
  {
    id: 20,
    title: '周处除三害',
    englishTitle: 'The Pig, The Snake and The Pigeon',
    year: 2024,
    rating: 8.4,
    category: 'action',
    region: '中国台湾',
    coverImage: 'https://readdy.ai/api/search-image?query=Taiwanese%20crime%20action%20movie%20poster%2C%20a%20man%20in%20dark%20clothing%20walking%20through%20rainy%20neon-lit%20Taipei%20street%2C%20intense%20and%20gritty%20atmosphere%2C%20green%20and%20amber%20neon%20lights%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-cover-20&orientation=portrait',
    description: '通缉犯陈桂林在得知自己身患绝症后，决定效仿周处除三害的故事，在生命终结前除掉排名在自己之前的两个通缉犯。他由此踏上了一段疯狂的救赎之旅。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文', '王净'],
    duration: '134分钟',
    isHot: false,
    isNew: true,
    rank: 20,
  },
];

export const hotMovies = movies.filter(m => m.isHot).sort((a, b) => a.rank - b.rank);
export const newMovies = movies.filter(m => m.isNew).sort((a, b) => a.rank - b.rank);
export const topRankedMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

export function getMoviesByCategory(slug: string): Movie[] {
  if (slug === 'all') return movies;
  return movies.filter(m => m.category === slug);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 6): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && m.category === movie.category)
    .slice(0, count);
}